import useToastStore from "@lib/stores/toast";
import ReactDOM from "react-dom";
import Toast from "./Toast"; // Assuming Toast.jsx is in the same directory

const ToastContainer = ({ position }) => {
  const { toasts, removeToast, toastCounter } = useToastStore();

  // Filter toasts for this specific position
  const toastsForPosition = toasts.filter((toast) => toast.position === position);

  const getPositionClass = (pos) => {
    switch (pos) {
      case "top-left":
        return "toast-top toast-start";
      case "top-right":
        return "toast-top toast-end";
      case "bottom-left":
        return "toast-bottom toast-start";
      case "bottom-right":
        return "toast-bottom toast-end";
      case "top-center":
        return "toast-top toast-center";
      case "bottom-center":
        return "toast-bottom toast-center";
      default:
        return "toast-bottom toast-end"; // Default to bottom-right
    }
  };

  if (toastsForPosition.length === 0) {
    return null; // Don't render anything if there are no toasts for this position
  }

  // Create a specific container for each position
  const containerId = `toast-container-${position}`;
  let container = document.getElementById(containerId);
  if (!container) {
    container = document.createElement("div");
    container.id = containerId;
    container.className = `toast ${getPositionClass(position)}`;
    document.body.appendChild(container);
  }

  return ReactDOM.createPortal(
    toastsForPosition.map((toast) => (
      <Toast
        key={`${toast.id}-${toastCounter}`} // Use toastCounter for stable key
        type={toast.type}
        text={toast.text}
        animation={
          toast.closing
            ? `animate-fade-out animate-duration-${toast.animationDuration}`
            : toast.animation
        }
        animationDuration={toast.animationDuration}
        onClick={() => removeToast(toast.id)}
      />
    )),
    container,
  );
};

export default ToastContainer;
